import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ENTITLEMENTS_REDUCER_NAME, EntitlementsReducer } from './types';
import { RequestStatus } from '../../../enums/requestStatus';
import { EntitlementsResponse } from '../../../models/entitlements';

const initialState: EntitlementsReducer = {
  data: null,
  status: null,
  error: null,
};

const entitlementsSlice = createSlice({
  name: ENTITLEMENTS_REDUCER_NAME,
  initialState,
  reducers: {
    fetchEntitlementsStarted(state) {
      state.status = RequestStatus.FETCHING;
      state.error = null;
    },
    fetchEntitlementsSuccess(state, { payload }: PayloadAction<EntitlementsResponse>) {
      state.data = payload;
      state.status = RequestStatus.SUCCESS;
      state.error = null;
    },
    fetchEntitlementsFailed(state, { payload }: PayloadAction<string | null>) {
      state.status = RequestStatus.FAILED;
      state.error = payload ?? null;
    },
    clearEntitlements(state) {
      state.data = null;
      state.status = null;
      state.error = null;
    },
  },
});

export const entitlementsActions = entitlementsSlice.actions;
export default entitlementsSlice.reducer;
